import React, { Component } from 'react'

import PostForm from "components/Posts/PostForm";
import Posts from "components/Posts/Posts";

export default class PostCreateView extends Component {
    render() {
        return (
            <div>
                <PostForm />
                <Posts />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Posts/PostCreateView.jsx